import { useTrEnumNamespace as e } from "./useTrEnumNamespace.mjs";
//#region src/enums/useTrTravelGuideModerationStatus.ts
var t = () => e("travelGuideModerationStatus");
//#endregion
export { t as useTrTravelGuideModerationStatus };
